import React, { useState } from "react";
import styles from "./index.module.css";
import deleteRedIcon from "../../../../../assets/icons/mobileIcons/deleteOutlinedRed.png";
import deleteBlackIcon from "../../../../../assets/icons/mobileIcons/deleteOutlinedBlack.png";
import dragHandle from "../../../../../assets/linkItemDraggable.png";
import cancelIcon from "../../../../../assets/icons/mobileIcons/cancelWhite.png";
import copyIcon from "../../../../../assets/icons/mobileIcons/copy.png";
import { message } from "antd";
import {
    setDeletingLink,
    setLinksChanged,
    setNonStoreSectionsChanged,
    setSelectedLinkInBio
} from "../../../../../redux/slice/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { findDiff } from "../../../../Builder/builderServices/utils";
import { getBrandLogo } from "../../../utils";

const index = ({ link, showDivider, isMenuOpened, setIsMenuOpened, brandsIcons }) => {
    const { nonStoreSectionsChanged, selectedHeader, selectedLinkInBio } = useSelector((store) => store.root.dashboard);
    const [isDeleting, setIsDeleting] = useState(false);
    const dispatch = useDispatch();
    const iconSrc = getBrandLogo(brandsIcons, link?.url);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link?.url);
            message.success("Link copied to clipboard");
        } catch (err) {
            message.error("Failed to copy to clipboard");
        }
    };

    const handleDelete = async () => {
        let linkCopy;
        let section;
        let updatedSections;
        linkCopy = { ...link, isDeleted: true, sortId: -1 };
        if (selectedHeader === "LinkInBio") {
            section = { ...nonStoreSectionsChanged.filter((e) => e.id === link.parentId)[0] };
            section.links = section.links.map((e) => (e.id === link.id ? linkCopy : e));
            updatedSections = nonStoreSectionsChanged.map((e) => (e.id === section.id ? section : e));
            dispatch(setNonStoreSectionsChanged(updatedSections));
        }
        dispatch(setLinksChanged());
        findDiff();
        message.success("Link deleted successfully");
        setIsDeleting(false);
        dispatch(setSelectedLinkInBio(section));
    };
    return (
        <div className={styles.container}>
            <div
                className={`${styles.linkContainer} ${isMenuOpened ? styles.openedMenu : ""}`}
                onClick={(e) => {
                    e.stopPropagation();
                    setIsMenuOpened();
                }}
            >
                <div className={styles.details}>
                    <img className={styles.dragHandle} src={dragHandle} />
                    <img className={styles.socialLogo} src={iconSrc} />
                    <span className={styles.url}>{link.url}</span>
                </div>
                {isMenuOpened && (
                    <div className={styles.menu}>
                        <img
                            src={isDeleting ? deleteRedIcon : deleteBlackIcon}
                            className={styles.deleteIcon}
                            onClick={() => {
                                setIsDeleting(true);
                            }}
                        />
                        <img src={copyIcon} onClick={handleCopy} className={styles.copyIcon} />
                    </div>
                )}
                {isMenuOpened && isDeleting && (
                    <div className={styles.deleteContainer}>
                        <span className={styles.deleteLabel}>Delete forever</span>
                        <div className={styles.buttonsContainer}>
                            <div
                                className={styles.cancelButton}
                                onClick={() => {
                                    setIsDeleting(false);
                                }}
                            >
                                <img src={cancelIcon} />
                                <span>Cancel</span>
                            </div>
                            <div className={styles.deleteButton} onClick={handleDelete}>
                                <img src={deleteRedIcon} />
                                <span>Delete</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {showDivider && <div className={styles.divider}></div>}
        </div>
    );
};

export default index;
